package com.appsyde.shared.modules.auth.domain.usecase

import com.appsyde.shared.modules.auth.domain.model.DomainResult
import com.appsyde.shared.modules.auth.domain.repo.AuthRepository

/** V1 Landing: Se connecter — retourne l'URL OAuth identity-only. */
class GetLoginUrlLandingUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(redirectUri: String): DomainResult<String> =
        authRepository.getLoginUrlLanding(redirectUri)
}
